export var ApiUrls;
(function (ApiUrls) {
    ApiUrls["Answer"] = "/v1/reviews/:reviewId/answer";
    ApiUrls["Review"] = "/v1/reviews/:reviewId";
})(ApiUrls || (ApiUrls = {}));
